import { render, staticRenderFns } from "./AccountBalanceTotal.vue?vue&type=template&id=6f8d0d60&"
import script from "./AccountBalanceTotal.vue?vue&type=script&lang=ts&"
export * from "./AccountBalanceTotal.vue?vue&type=script&lang=ts&"
import style0 from "./AccountBalanceTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports